import * as messages from "../../messages";
import { OnboardingVisitId, VisitBroadcastId } from "../../messages/ObjectIds";
import { genericUpdate } from "../../utils/generic_update";
import { KeyedList } from "../../utils/List";

export interface AppVisitsState {
  readonly visits: KeyedList<Visit, "id">;
}

export type VisitType = "Available" | "Onboarding";
export type Visit = Visit.Available | Visit.Onboarding;
export type VisitId = VisitBroadcastId | OnboardingVisitId;

export declare namespace Visit {
  export type Available = messages.CaregiverVisitBroadcastTypes.Available;
  export type Onboarding = messages.CaregiverVisitBroadcastTypes.Onboarding;
}

export class AppVisitsState {
  static parseVisit = (singleVisit: messages.CaregiverVisitBroadcast): Visit => {
    return singleVisit;
  };

  static fromMessage = (message: messages.CaregiverVisitBroadcastList): AppVisitsState => {
    return AppVisitsState.fromCaregiverVisitBroadcastListMessage(message);
  };

  private static fromCaregiverVisitBroadcastListMessage = (
    message: messages.CaregiverVisitBroadcastList
  ): AppVisitsState => {
    let visits = KeyedList.empty<Visit>()("id");

    message.visitBroadcasts.forEach((visit) => {
      visits = visits.append(AppVisitsState.parseVisit(visit));
    });

    return {
      visits: visits,
    };
  };

  static updateFromMessage = (
    appVisitsState: AppVisitsState,
    message: messages.CaregiverVisitBroadcastList
  ): AppVisitsState => {
    return genericUpdate(appVisitsState, AppVisitsState.fromMessage(message));
  };

  static setVisitMoreDetailsViewed = (
    appVisitsState: AppVisitsState,
    visitId: VisitBroadcastId
  ): AppVisitsState => {
    const newVisits = appVisitsState.visits.mapKeyedList("id", (visit: Visit): Visit => {
      if (visit.id === visitId && visit.type === "Available") {
        return {
          ...visit,
          caregiverVisitEngagementDetails: {
            ...visit.caregiverVisitEngagementDetails,
            moreDetailsViewed: true,
          },
        };
      } else {
        return visit;
      }
    });

    return {
      ...appVisitsState,
      visits: newVisits,
    };
  };
}
